exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".I9_6l{position:absolute;z-index:50;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;width:100%;height:100%;background-color:black;justify-content:center;align-items:center}.I9_6l._3ufRt video,.I9_6l._3nIJ3 video{width:100%;height:100%}.I9_6l.SIros video{position:absolute}.I9_6l._3Mqu6.SIros video{width:100%;height:auto !important}.I9_6l._1EHTP.SIros video{height:100%}.I9_6l video{position:relative;z-index:1;box-shadow:0 0 20px rgba(0,0,0,0.2)}.I9_6l._7BJmM{cursor:none}._2tEfc{position:absolute;z-index:0;top:0;right:0;bottom:0;left:0;filter:blur(14px)}\n", ""]);

// Exports
exports.locals = {
	"screen": "I9_6l",
	"regularMode": "_3ufRt",
	"blurMode": "_3nIJ3",
	"fillMode": "SIros",
	"verticalStripes": "_3Mqu6",
	"horizontalStripes": "_1EHTP",
	"hiddenCursor": "_7BJmM",
	"backgroundCanvas": "_2tEfc"
};